import { DteEmitido } from "../Dte/DteEmitido";
import { DetalleCesion } from "./DetalleCesion";

export class Cesion {
   public cesionId: string;
   public emisorId: string;
   public dteId: string;
   public personaAutorizadaCesionId: string;
   public rutPersonaAutorizada: number;
   public dvPersonaAutorizada: string;
   public nombrePersonaAutorizada: string;
   public correoPersonaAutorizada: string;
   public fechaEmision: Date;
   public rutEmisor: number;
   public codigoTipoDte: number;
   public folio: number;
   public montoTotal: number;
   public estado: number;
   public estadoDescripcion: number;
   public trackId: number;
   public anulado: boolean;
   public dte: DteEmitido;
   public detalles: DetalleCesion[];
   showActions?: boolean;
}
